/**
 * Created by user on 2018/2/17/017.
 */

export { zh2jp, zht2jp, zhs2jp, zhs2zht, zht2zhs, cjk2zhs, jp2zhs, jp2zht, cjk2zht, cjk2jp, IOptions } from '@lazy-cjk/jp-table-convert';

export default exports as typeof import('./index');
